import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import { Button } from 'components/Button'
import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef } from 'react'
import { ReactComponent as DownIcon } from '../icons/chevronDown.svg'
import { ReactComponent as UpIcon } from '../icons/chevronUp.svg'
import { useForwardRef } from '../../../../../hooks/useForwardRef'
import Styles from './FontFamilyGroup.module.scss'
import { FontFamilySearchInput } from './FontFamilySearchInput'
import { FontFamilyContext, getStillInsideWindowClickSignaler } from './stores/FontFamilyStore'

export const FontFamilyMainButton = observer(function FontFamilyMainButton() {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const fontFamilyStore = useContext(FontFamilyContext)!
  const buttonRef = useForwardRef<HTMLButtonElement>(fontFamilyStore.setFontFamilyAnchor)
  const chevronRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    const inButton = getStillInsideWindowClickSignaler(buttonRef)
    fontFamilyStore.registerWindowClickSignaler(inButton)
    return () => fontFamilyStore.unregisterWindowClickSignaler(inButton)
  })

  useEffect(() => {
    const inChevron = getStillInsideWindowClickSignaler(chevronRef)
    fontFamilyStore.registerWindowClickIgnorer(inChevron)
    return () => fontFamilyStore.unregisterWindowClickIgnorer(inChevron)
  })

  const handleChevronClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    if (fontFamilyStore.showingFontFamilyDropdown) {
      fontFamilyStore.hardClose()
      return
    }
    fontFamilyStore.hardOpen()
  }

  return (
    <ShortcutAwareTooltip label="Font">
      <Button
        variant="tertiary"
        size="lg"
        aria-label={fontFamilyStore.firstActiveFontDefinition}
        onPress={fontFamilyStore.hardOpen}
        ref={buttonRef}
        className={Styles.mainButton}
      >
        <FontFamilySearchInput />
        <span ref={chevronRef} className={Styles.chevron} onClick={handleChevronClick}>
          {fontFamilyStore.showingFontFamilyDropdown ? <UpIcon /> : <DownIcon />}
        </span>
      </Button>
    </ShortcutAwareTooltip>
  )
})
